"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiInput = _interopRequireDefault(require("@tencent/spaui-input"));

var _spauiFormgroup = _interopRequireDefault(require("@tencent/spaui-formgroup"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPopover = require("@tencent/spaui-popover");

var _validate = require("../utils/validate");

var _classnames = _interopRequireDefault(require("classnames"));

var _data = require("../config/data");

var _utils = require("../utils");

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DatePlayComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DatePlayComponent, _PureComponent);

  function DatePlayComponent(props) {
    var _this;

    _classCallCheck(this, DatePlayComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePlayComponent).call(this, props));
    _this.state = {
      value: _this.getValue(props),
      inputErrorTip: '',
      isInputFocus: false
    };
    _this.locale = (0, _spauiUtils.objectAssign)({}, _config.defaultLocale, props.locale); // 生成input的id

    _this.inputId = (0, _spauiUtils.getUniqueId)('spaui-datepicker-input');
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.triggerChange = _this.triggerChange.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.onDateInputFocus = _this.onDateInputFocus.bind(_assertThisInitialized(_this));
    _this.onDateBlurFocus = _this.onDateBlurFocus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DatePlayComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var mountTarget = this.props.mountTarget; // 挂在在别的对象的，有可能生命周期会有差别，所以稍微延时一下

      if (mountTarget === 'body' || _typeof(mountTarget) === 'object' && mountTarget) {
        setTimeout(function () {
          _this2.focus();
        }, 40);
      } else {
        this.focus();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          _this$props$startDate = _this$props.startDateData,
          startDateData = _this$props$startDate === void 0 ? {} : _this$props$startDate,
          _this$props$endDateDa = _this$props.endDateData,
          endDateData = _this$props$endDateDa === void 0 ? {} : _this$props$endDateDa,
          label = _this$props.label;
      var _nextProps$startDateD = nextProps.startDateData,
          nextStartDateData = _nextProps$startDateD === void 0 ? {} : _nextProps$startDateD,
          _nextProps$startDateD2 = nextProps.startDateData,
          nextEndDateData = _nextProps$startDateD2 === void 0 ? {} : _nextProps$startDateD2;
      var hourOfStartDate = startDateData.hour;
      var hourOfEndDate = endDateData.hour;
      var hourOfNextStartDate = nextStartDateData.hour;
      var hourOfNextEndDate = nextEndDateData.hour;

      if (nextProps.label !== label || hourOfStartDate !== hourOfNextStartDate || hourOfEndDate !== hourOfNextEndDate) {
        this.setState({
          value: this.getValue(nextProps),
          inputErrorTip: ''
        });
      }
    } // 获取input的dom

  }, {
    key: "getInput",
    value: function getInput() {
      return document.getElementById(this.inputId) || null;
    } // input如果可输入，打开的时候聚焦

  }, {
    key: "focus",
    value: function focus() {
      var readOnly = this.readOnly();
      var $input = this.getInput();

      if (!readOnly && $input) {
        $input.focus();
      }
    } // 是否只读

  }, {
    key: "readOnly",
    value: function readOnly(theProps) {
      var props = theProps || this.props || {};
      var input = props.input,
          disabled = props.disabled;
      return !input || disabled;
    } // 获取值

  }, {
    key: "getValue",
    value: function getValue(theProps) {
      var props = theProps || this.props || {};
      var _props$label = props.label,
          label = _props$label === void 0 ? '' : _props$label,
          _props$placeholder = props.placeholder,
          placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
          _props$type = props.type,
          type = _props$type === void 0 ? '' : _props$type,
          _props$dateData = props.dateData,
          dateData = _props$dateData === void 0 ? {} : _props$dateData,
          _props$startDateData = props.startDateData,
          startDateData = _props$startDateData === void 0 ? {} : _props$startDateData,
          _props$endDateData = props.endDateData,
          endDateData = _props$endDateData === void 0 ? {} : _props$endDateData,
          timePickerProps = props.timePickerProps,
          startTimePickerProps = props.startTimePickerProps,
          endTimePickerProps = props.endTimePickerProps,
          format = props.format,
          getDateValue = props.getDateValue,
          unlimitedDateValue = props.unlimitedDateValue,
          unlimitedDateValueLabel = props.unlimitedDateValueLabel,
          startDateCanBeUnlimited = props.startDateCanBeUnlimited,
          endDateCanBeUnlimited = props.endDateCanBeUnlimited,
          _props$canChooseOneDa = props.canChooseOneDateByRange,
          canChooseOneDateByRange = _props$canChooseOneDa === void 0 ? true : _props$canChooseOneDa,
          inputDateFormat = props.inputDateFormat,
          inputDateSeparator = props.inputDateSeparator;
      var result = '';

      if (this.readOnly(props)) {
        if (label !== placeholder) {
          result = label;
        }
      } else {
        if (type === 'single') {
          result = (0, _validate.formatDate)(dateData, timePickerProps, inputDateFormat);
        } else if (type === 'range') {
          // 是否无限日期
          if (startDateCanBeUnlimited && (0, _spauiUtils.joinDate)(startDateData, format) === getDateValue('startDate', unlimitedDateValue, props)) {
            result = unlimitedDateValueLabel;
          } else {
            result = (0, _validate.formatDate)(startDateData, startTimePickerProps, inputDateFormat);
          } // 是否无限日期


          if (endDateCanBeUnlimited && (0, _spauiUtils.joinDate)(endDateData, format) === getDateValue('endDate', unlimitedDateValue, props)) {
            // 双日期中间是-
            if (result) {
              result = result + inputDateSeparator;
            }

            result = result + unlimitedDateValueLabel;
          } else {
            // 双日期中间是-
            if (result) {
              if (!canChooseOneDateByRange || (0, _validate.formatDate)(endDateData, endTimePickerProps, inputDateFormat)) {
                result = result + inputDateSeparator;
              }
            }

            result = result + (0, _validate.formatDate)(endDateData, endTimePickerProps, inputDateFormat);
          }
        }
      }

      return result;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props2 = this.props,
          _this$props2$type = _this$props2.type,
          type = _this$props2$type === void 0 ? '' : _this$props2$type,
          onRealtimeChange = _this$props2.onRealtimeChange,
          onYearAndMonthChange = _this$props2.onYearAndMonthChange,
          timePickerProps = _this$props2.timePickerProps,
          startTimePickerProps = _this$props2.startTimePickerProps,
          endTimePickerProps = _this$props2.endTimePickerProps,
          unlimitedDateValueLabel = _this$props2.unlimitedDateValueLabel,
          unlimitedDateValue = _this$props2.unlimitedDateValue,
          getDateValue = _this$props2.getDateValue,
          format = _this$props2.format,
          propsStartDateData = _this$props2.startDateData,
          propsEndDateData = _this$props2.endDateData,
          startDateCanBeUnlimited = _this$props2.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _this$props2.endDateCanBeUnlimited,
          maxHour = _this$props2.maxHour;
      var value = event.target.value; // 先进行日期格式的转换

      var formatValue = (0, _validate.transInputDateTimeFormat)((0, _spauiUtils.trim)(value) || '', this.props);
      var validateResult = (0, _validate.validate)(formatValue, this.props);
      var valueArr = [];
      var dateData = {};
      var startDateData = {};
      var endDateData = {};
      var triggerYearAndMonthChange = '';
      var key = '';
      var startDateIsUnlimited = false;
      var endDateIsUnlimited = false;

      if ((0, _spauiUtils.isFunction)(onRealtimeChange)) {
        if (type === 'single') {
          if (validateResult.type === 'success') {
            // 验证成功后需要回传下选择的数据，以及选择的年月以便面板的年月能够变更
            dateData = (0, _validate.splitValue)(formatValue, timePickerProps);
            onRealtimeChange(event, type, dateData); // 有年份才做年月切换，避免因为日期为空导致面板展示错误

            if ((0, _spauiUtils.isFunction)(onYearAndMonthChange) && dateData.year) {
              onYearAndMonthChange(event, type, dateData.year, dateData.month);
            }
          }
        } else {
          valueArr = formatValue.split(_data.RANGE_DATE_SEPARATOR) || [];

          if (validateResult.type === 'success' || validateResult.type === 'startDate success') {
            // 如果是无限日期的话，替换下内容
            if (startDateCanBeUnlimited && unlimitedDateValueLabel && valueArr[0] === unlimitedDateValueLabel) {
              valueArr[0] = (0, _validate.formatDate)((0, _spauiUtils.splitDate)(getDateValue('startDate', unlimitedDateValue), format, {
                maxHour: maxHour
              }), startTimePickerProps);
              startDateIsUnlimited = true;
            }

            if (endDateCanBeUnlimited && unlimitedDateValueLabel && valueArr[1] === unlimitedDateValueLabel) {
              valueArr[1] = (0, _validate.formatDate)((0, _spauiUtils.splitDate)(getDateValue('endDate', unlimitedDateValue), format, {
                maxHour: maxHour
              }), endTimePickerProps);
              endDateIsUnlimited = true;
            } // 需要判断下大小


            if (valueArr[0] > valueArr[1] && valueArr[1]) {
              startDateData = (0, _validate.splitValue)(valueArr[1], startTimePickerProps);
              endDateData = (0, _validate.splitValue)(valueArr[0], endTimePickerProps);
            } else {
              startDateData = (0, _validate.splitValue)(valueArr[0], startTimePickerProps);
              endDateData = (0, _validate.splitValue)(valueArr[1], endTimePickerProps);
            } // 有年份才做年月切换，避免因为日期为空导致面板展示错误


            if ((0, _spauiUtils.isFunction)(onYearAndMonthChange) && startDateData.year) {
              // 有变化才做触发
              // 如果是无限日期的就不触发年月变更了
              for (key in startDateData) {
                if (startDateData[key] !== propsStartDateData[key] && !startDateIsUnlimited) {
                  triggerYearAndMonthChange = 'startDateData';
                }
              }

              for (key in endDateData) {
                if (endDateData[key] !== propsEndDateData[key] && !endDateIsUnlimited) {
                  triggerYearAndMonthChange = 'endDateData';
                }
              }

              if (triggerYearAndMonthChange) {
                if (startDateCanBeUnlimited && triggerYearAndMonthChange === 'endDateData') {
                  // 两个日期都成功才切换右边面板
                  if (validateResult.type === 'success') {
                    onYearAndMonthChange(event, 'end', endDateData.year, endDateData.month);
                  }
                } else {
                  onYearAndMonthChange(event, 'start', startDateData.year, startDateData.month, function () {
                    // 两个日期都成功才切换右边面板
                    if (validateResult.type === 'success') {
                      onYearAndMonthChange(event, 'end', endDateData.year, endDateData.month);
                    }
                  });
                }
              }
            }

            onRealtimeChange(event, type, {
              startData: startDateData,
              endData: endDateData
            });
          }
        }
      }

      this.setState({
        value: value,
        inputErrorTip: validateResult.msg || ''
      });
    } // 根据输入框的值响应回调

  }, {
    key: "triggerChange",
    value: function triggerChange(event) {
      var _this$props3 = this.props,
          triggerChange = _this$props3.triggerChange,
          type = _this$props3.type,
          timePickerProps = _this$props3.timePickerProps,
          startTimePickerProps = _this$props3.startTimePickerProps,
          endTimePickerProps = _this$props3.endTimePickerProps,
          unlimitedDateValueLabel = _this$props3.unlimitedDateValueLabel,
          unlimitedDateValue = _this$props3.unlimitedDateValue,
          startDateCanBeUnlimited = _this$props3.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _this$props3.endDateCanBeUnlimited;
      var $input = this.getInput();
      var value = '';
      var validateResult = {};
      var valueArr = [];
      var triggerData = {};

      if ($input) {
        // 先进行日期格式的转换
        value = (0, _validate.transInputDateTimeFormat)((0, _spauiUtils.trim)($input.value) || '', this.props);
        valueArr = value.split(_data.RANGE_DATE_SEPARATOR) || [];
        validateResult = (0, _validate.validate)(value, this.props); // 失去焦点的时候要验证下内容

        if (validateResult.type === 'success' && (0, _spauiUtils.isFunction)(triggerChange)) {
          if (type === 'single') {
            triggerChange(event, type, {
              data: (0, _validate.splitValue)(value, timePickerProps)
            });
          } else if (type === 'range') {
            // 需要判断下大小
            if (valueArr[0] > valueArr[1] && valueArr[0] !== unlimitedDateValueLabel) {
              triggerData = {
                startData: (0, _validate.splitValue)(valueArr[1], startTimePickerProps),
                endData: (0, _validate.splitValue)(valueArr[0], endTimePickerProps)
              };
            } else {
              triggerData = {
                startData: (0, _validate.splitValue)(valueArr[0], startTimePickerProps),
                endData: (0, _validate.splitValue)(valueArr[1], endTimePickerProps)
              };
            } // 无限日期


            if (valueArr[0] && valueArr[0] === unlimitedDateValueLabel && startDateCanBeUnlimited) {
              triggerData.startData = unlimitedDateValue;
            }

            if (valueArr[1] && valueArr[1] === unlimitedDateValueLabel && endDateCanBeUnlimited) {
              triggerData.endData = unlimitedDateValue;
            }

            triggerChange(event, type, triggerData);
          }
        }
      }
    } // 回车

  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      var onOpen = this.props.onOpen; // 回车的时候掉用下失去焦点的逻辑，并且关闭

      if (event.charCode === 13) {
        this.triggerChange(event);

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event);
        }
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var onOpen = this.props.onOpen; // tab键

      if (event.keyCode === 9) {
        this.triggerChange(event);

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event);
        }
      }
    } // 是否展示提示

  }, {
    key: "showPopOver",
    value: function showPopOver() {
      var _this$props4 = this.props,
          _this$props4$type = _this$props4.type,
          type = _this$props4$type === void 0 ? '' : _this$props4$type,
          _this$props4$date = _this$props4.date,
          date = _this$props4$date === void 0 ? '' : _this$props4$date,
          _this$props4$startDat = _this$props4.startDate,
          startDate = _this$props4$startDat === void 0 ? '' : _this$props4$startDat,
          _this$props4$endDate = _this$props4.endDate,
          endDate = _this$props4$endDate === void 0 ? '' : _this$props4$endDate;
      var _this$state = this.state,
          _this$state$value = _this$state.value,
          value = _this$state$value === void 0 ? '' : _this$state$value,
          _this$state$inputErro = _this$state.inputErrorTip,
          inputErrorTip = _this$state$inputErro === void 0 ? '' : _this$state$inputErro;
      var validateResult = (0, _validate.validate)(value, this.props);
      var result = inputErrorTip.length > 0 && !this.readOnly(); // 如果原来没有值的，在value过小的时候不进行提示

      if (type === 'single') {
        // 一开始没有日期在输入过短的时候不提示
        if (!date && validateResult.type === 'value too short') {
          result = false;
        }
      } else if (type === 'range') {
        // 一开始没有日期在输入过短的时候不提示
        if (!startDate && !endDate && validateResult.type === 'value too short' || validateResult.type === 'startDate success') {
          result = false;
        }
      }

      return result;
    }
  }, {
    key: "handleClear",
    value: function handleClear(event) {
      var _this$props5 = this.props,
          onInsideClick = _this$props5.onInsideClick,
          onInputValueClear = _this$props5.onInputValueClear;

      if ((0, _spauiUtils.isFunction)(onInsideClick)) {
        onInsideClick();
      }

      if ((0, _spauiUtils.isFunction)(onInputValueClear)) {
        onInputValueClear(event);
      }

      event.target.value = '';
      this.handleChange(event);
      this.getInput().focus();
    } // 日期输入框被 focus 操作

  }, {
    key: "onDateInputFocus",
    value: function onDateInputFocus() {
      this.setState({
        isInputFocus: true
      });
    } // 日期输入框被 blur 操作

  }, {
    key: "onDateBlurFocus",
    value: function onDateBlurFocus() {
      var onBlur = this.props.onBlur;
      this.setState({
        isInputFocus: false
      });
      onBlur();
    }
    /**
       * 将日期数据转换成非聚焦格式的值（比如聚焦的时候是： '20190905 1212', 非聚焦的时候是: '2019.09.05 12:12'）
       * @param {*} dateValue 日期值
       */

  }, {
    key: "translateNotFocusDateValue",
    value: function translateNotFocusDateValue() {
      var dateValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props6 = this.props,
          type = _this$props6.type,
          timePicker = _this$props6.timePicker; // 先进行日期格式的转换

      var formatValue = (0, _validate.transInputDateTimeFormat)((0, _spauiUtils.trim)(dateValue) || '', this.props);
      var validateResult = (0, _validate.validate)(formatValue, this.props); // 只有数据的格式是成功的，非聚焦状态下才能转换成正常的格式
      // 目前只转换范围日期加带时间的

      if (validateResult.type === 'success' && type === 'range' && timePicker) {
        var newDateValue = (0, _spauiUtils.trim)(formatValue) || '';
        var valueArr = newDateValue.split(_data.RANGE_DATE_SEPARATOR) || [];
        return (0, _validate.formatRangeDateTimeValueToDisplayValue)(valueArr[0] || '', valueArr[1] || '');
      } // 验证不成功，使用聚焦时的日期值（不进行转换）


      return dateValue;
    } // 处理固定周选择器边界情况

  }, {
    key: "formatSingleOptionalWeek",
    value: function formatSingleOptionalWeek(type, strValue, prefix, fixedNumber, optionalStartDateData, optionalEndDateData, firstDayOfWeek, endDayOfWeek) {
      var optionalStartYear = optionalStartDateData.year,
          optionalStartMonth = optionalStartDateData.month,
          optionalStartDate = optionalStartDateData.date;
      var optionalEndYear = optionalEndDateData.year,
          optionalEndMonth = optionalEndDateData.month,
          optionalEndDate = optionalEndDateData.date;
      var value = strValue;

      if (type === 'single' && fixedNumber) {
        if (value) {
          var values = value.split(prefix).filter(function (item) {
            return item;
          }); // 去掉空项

          if (values.length === 1) {
            var last = (0, _utils.getLastWeekByNumber)(values[0], fixedNumber);
            var startDate = Math.min(new Date(values[0]).getTime(), new Date(last).getTime());
            var endDate = Math.max(new Date(values[0]).getTime(), new Date(last).getTime());
            value = (0, _utils.formatDateAlias)(startDate) + prefix + (0, _utils.formatDateAlias)(endDate);

            if (fixedNumber > 0) {
              var optionalEnd = (0, _utils.formatDateAlias)(new Date(optionalEndYear, optionalEndMonth, optionalEndDate)); // 可选截止范围

              var rangeEndMonth = (0, _utils.getRangeWeekDays)(values[0], optionalEnd, firstDayOfWeek, endDayOfWeek);

              if (new Date((0, _utils.formatDateAlias)(last)).getTime() >= new Date((0, _utils.formatDateAlias)(optionalEnd)).getTime()) {
                value = (0, _utils.formatDateAlias)(rangeEndMonth[0]) + prefix;

                if (rangeEndMonth.length > 1) {
                  value += (0, _utils.formatDateAlias)(rangeEndMonth[rangeEndMonth.length - 1]);
                }
              }
            } else {
              var optionalStart = (0, _utils.formatDateAlias)(new Date(optionalStartYear, optionalStartMonth, optionalStartDate)); // 可选起始范围

              var rangeStartMonth = (0, _utils.getRangeWeekDays)(optionalStart, values[0], firstDayOfWeek, endDayOfWeek);

              if (new Date((0, _utils.formatDateAlias)(last)).getTime() <= new Date((0, _utils.formatDateAlias)(optionalStart)).getTime()) {
                value = (0, _utils.formatDateAlias)(rangeStartMonth[0]) + prefix;

                if (rangeStartMonth.length > 1) {
                  value += (0, _utils.formatDateAlias)(rangeStartMonth[rangeStartMonth.length - 1]);
                }
              }
            }
          }
        }
      }

      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          type = _this$props7.type,
          clear = _this$props7.clear,
          picker = _this$props7.picker,
          placeholder = _this$props7.placeholder,
          _this$props7$classNam = _this$props7.classNameMap,
          classNameMap = _this$props7$classNam === void 0 ? {} : _this$props7$classNam,
          disabled = _this$props7.disabled,
          _this$props7$locale = _this$props7.locale,
          locale = _this$props7$locale === void 0 ? {} : _this$props7$locale,
          setLabel = _this$props7.setLabel,
          _this$props7$showDate = _this$props7.showDatePlay,
          showDatePlay = _this$props7$showDate === void 0 ? true : _this$props7$showDate,
          inputProps = _this$props7.inputProps,
          elementRef = _this$props7.elementRef,
          firstDayOfWeek = _this$props7.firstDayOfWeek,
          endDayOfWeek = _this$props7.endDayOfWeek,
          fixedNumber = _this$props7.fixedNumber,
          optionalStartDateData = _this$props7.optionalStartDateData,
          optionalEndDateData = _this$props7.optionalEndDateData;
      var _this$state2 = this.state,
          _this$state2$inputErr = _this$state2.inputErrorTip,
          inputErrorTip = _this$state2$inputErr === void 0 ? '' : _this$state2$inputErr,
          isInputFocus = _this$state2.isInputFocus;
      var value = this.state.value;
      var readOnly = this.readOnly();
      var showPopOver = !readOnly && this.showPopOver();
      var style = {};
      var dateInputValue = value;

      if (picker === 'week') {
        dateInputValue = placeholder;
        var prefix = " ".concat((0, _utils.isSafari)() ? '-' : this.locale.separateLabel, " ");
        value = this.formatSingleOptionalWeek(type, value, prefix, fixedNumber, optionalStartDateData, optionalEndDateData, firstDayOfWeek, endDayOfWeek);

        if (value) {
          if (value.indexOf(prefix) > -1) {
            var values = value.split(prefix).filter(function (item) {
              return item;
            }); // 去掉空项

            if (values.length === 1) {
              dateInputValue = "".concat((0, _utils.getWeekOfYearByDate)(values[0], firstDayOfWeek, endDayOfWeek), "\u5468");
            } else if (values.length > 1) {
              var start = Math.min(new Date(values[0]).getTime(), new Date(values[1]).getTime());
              var end = Math.max(new Date(values[0]).getTime(), new Date(values[1]).getTime());

              if (!isNaN(start) && !isNaN(end)) {
                var startWeekOfYear = (0, _utils.getWeekOfYearByDate)(start, firstDayOfWeek, endDayOfWeek);
                var endWeekOfYear = (0, _utils.getWeekOfYearByDate)(end, firstDayOfWeek, endDayOfWeek);

                if (startWeekOfYear && startWeekOfYear !== '-') {
                  dateInputValue = "".concat(startWeekOfYear, "\u5468");

                  if (startWeekOfYear !== endWeekOfYear) {
                    if (endWeekOfYear && endWeekOfYear !== '-') {
                      dateInputValue += "\u81F3".concat(endWeekOfYear, "\u5468");
                    }
                  }
                }
              } else {
                dateInputValue = "".concat((0, _utils.getWeekOfYearByDate)(values[0], firstDayOfWeek, endDayOfWeek), "\u5468\u81F3").concat(values[1]);
              }
            }
          } else {
            dateInputValue = "".concat((0, _utils.getWeekOfYearByDate)(value, firstDayOfWeek, endDayOfWeek), "\u5468");
          }
        }
      } else {
        // 如果 input 是非聚焦状态，需要将日期数据转换成一种更加友好的格式
        if (!isInputFocus) {
          dateInputValue = this.translateNotFocusDateValue(value);
        }
      } // 指定不展示就隐藏起来


      if (!showDatePlay) {
        style.display = 'none';
      }

      return _react["default"].createElement("div", {
        className: classNameMap.DatePickerPlayClassName,
        style: style,
        ref: elementRef
      }, _react["default"].createElement(_spauiFormgroup["default"], {
        locale: locale,
        setLabel: setLabel,
        classNameMap: {
          bootstrapFormGroup: ''
        },
        clearable: Boolean(value && clear),
        clear: value && clear,
        onClear: this.handleClear,
        status: showPopOver ? 'error' : '' // prefix={useNewUI} 麻烦 Zale 将 Shortcuts 里选择的内容显示在此处，另外看是否提供开关关掉此功能

      }, _react["default"].createElement(_spauiPopover.OverlayTrigger, {
        trigger: "click",
        placement: "top",
        overlay: _react["default"].createElement(_spauiPopover.PopOver, {
          style: {
            maxWidth: '420px'
          }
        }, _react["default"].createElement("div", {
          dangerouslySetInnerHTML: {
            __html: inputErrorTip
          }
        })),
        show: showPopOver
      }, _react["default"].createElement("div", null, _react["default"].createElement(_spauiInput["default"], _extends({
        className: (0, _classnames["default"])({
          disabled: disabled
        })
      }, inputProps || {}, {
        id: this.inputId,
        readOnly: readOnly,
        placeholder: placeholder,
        value: dateInputValue,
        onFocus: this.onDateInputFocus,
        onBlur: this.onDateBlurFocus,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        onKeyDown: this.handleKeyDown
      }))))));
    }
  }]);

  return DatePlayComponent;
}(_react.PureComponent);

var _default = DatePlayComponent;
exports["default"] = _default;